module.exports = __webpack_public_path__ + "img/tiktok.456dae59.svg";